import { registerCueSounds } from '@/vue/features/cue/activity/bootstrap/registerCueSounds';
import { lockViewportScrollOnIos } from '@/vue/features/shared/layout/services/viewportScrollLock';
import { unlockAudioPlaybackOnFirstGesture } from '@/vue/features/shared/sound/services/audioUnlock';

export const bootstrapApp = (): void => {
    registerCueSounds();
    unlockAudioPlaybackOnFirstGesture();
    lockViewportScrollOnIos();
};
